// @ts-expect-error Untyped module
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
import { TEAM, USER
// @ts-expect-error Untyped module
} from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error Untyped module
import TeamReferenceResolver from 'reference-resolvers/resolvers/TeamReferenceResolver';
// @ts-expect-error Untyped module
import UserReferenceResolver from 'reference-resolvers/resolvers/UserReferenceResolver';
const resolvers = {
  [USER]: UserReferenceResolver,
  [TEAM]: TeamReferenceResolver
};
export default ((additionalResolvers = {}) => ProvideReferenceResolvers(Object.assign({}, resolvers, additionalResolvers), ({
  children
}) => children));